import { Component } from '@angular/core';

@Component({
    selector: 'app-fixedcuttersap-data',
    templateUrl: './fixedcuttersap-data.component.html',
    styleUrl: './fixedcuttersap-data.component.css',
    standalone: false
})
export class FixedcuttersapDataComponent {

}
